export default __webpack_public_path__ + "static/media/check-bold.64c8fc49.svg";